'use client';

import { useMemo } from 'react';

import { useRealtimeDatabase } from 'hooks/useRealtimeDatabase';
import { Metrics } from 'models/Metrics';
import MetricsPure from '../MetricsPure';

interface MetricsRealtimeProps {
	metrics?: Metrics | null;
}

function MetricsRealtime(props: MetricsRealtimeProps) {
	// Hooks
	const metrics = useRealtimeDatabase<Metrics>('metrics');

	// Memo vars
	const data = useMemo(() => {
		return metrics.data ?? props.metrics;
	}, [metrics.data, props.metrics]);

	return <MetricsPure metrics={data} />;
}

export default MetricsRealtime;
